import {
  Inserter,
  SessionRole,
  DragAndDropContext,
  TinymcePortal,
  RouterPageNotFound,
  ErrorBoundry,
  PartAdmin,
  PartMenu,
  Wrapper,
  useLanguage,
} from "nystem-components";
import "./index.css";

const Index = () => {
  const lang = useLanguage();

  return (
    <ErrorBoundry fallback={<Inserter match="*" source="/page/view/404" />}>
      <DragAndDropContext>
        <TinymcePortal />
        <Wrapper key={lang} className="min-h-lvh bg-stone-100 text-stone-800 antialiased">
          <PartMenu />
          <SessionRole userrole="logged-out">
            <Wrapper className="flex flex-col items-center justify-center pt-16">
              <Inserter match="*" source="/user/login" />
            </Wrapper>
          </SessionRole>
          <Inserter match="/content/view/*" />
          <SessionRole userrole="logged-in">
            <Wrapper className="mx-auto w-full max-w-6xl px-4 py-8 md:px-8 print:max-w-none print:p-0">
              <PartAdmin />
              <Inserter match="/" source="/mission/pipeline" />
              <Inserter match="/stage/*" source="/mission/pipeline" />
              <Inserter match="/schedule" source="/mission/schedule" className="mx-auto max-w-4xl" />
              <Inserter match="/mission/*" className="mx-auto max-w-4xl" />
              <Inserter match="/customer/*" className="mx-auto max-w-4xl" />
              <RouterPageNotFound>
                <Inserter match="*" source="/page/view/404" />
              </RouterPageNotFound>
            </Wrapper>
          </SessionRole>
        </Wrapper>
      </DragAndDropContext>
    </ErrorBoundry>
  );
};

export default Index;
